import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { InputTextarea } from '../prime';
import { IControlProps, MapProps } from './';
import styles from './index.module.scss';

interface IProps extends IControlProps<string> {
  storage?: IDataStorage;
  /** Largo máximo permitido */
  maxLength?: number;
  /** Alto del componente */
  height?: number;

  /** class para el TextBox */
  inputClassName?: string;
  /** estilo para el TextBox */
  inputStyle?: React.CSSProperties;

  onlyBlurEvent?: boolean;
}

interface IState extends IControlProps<string> {
  storage?: IDataStorage;

  maxLength?: number;
  height?: number;

  inputClassName?: string;
  inputStyle?: React.CSSProperties;

  /** Indica el mensaje de error si es que existe */
  validError?: string;
  
  onlyBlurEvent?: boolean;
}

class Index extends React.Component<IProps, IState> {
  state: IState = {};
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => this.change(this.state.value));
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.maxLength !== s?.maxLength) res.maxLength = p.maxLength;
    if (p?.height !== s?.height) res.height = p.height;
    if (p?.inputClassName !== s?.inputClassName) res.inputClassName = p.inputClassName;
    if (p?.inputStyle !== s?.inputStyle) res.inputStyle = p.inputStyle;
    if (p?.onlyBlurEvent !== s?.onlyBlurEvent) res.onlyBlurEvent = p.onlyBlurEvent;
    return MapProps(res, p, s);
  }

  render() {
    const { validError, onlyBlurEvent } = this.state;
    
    return (
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons}`} style={{ height: this.state.height }}>
          {this.state.icon &&
            <span className={`p-inputgroup-addon`}>
              <i className={this.state.icon} />
            </span>
          }
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }
          <InputTextarea
            defaultValue={this.state.value}
            placeholder={this.state.placeholder}
            readOnly={this.state.disabled}
            maxLength={this.state.maxLength}
            tooltip={validError}
            tooltipOptions={{ position: 'bottom' }}
            autoResize={false}
            onChange={(e:any) => !onlyBlurEvent && !this.state.disabled && this.change((e.target as any).value)}
            onBlur={(e:any) => !this.state.disabled && this.change((e.target as any).value)}
            className={`w-100 p-inputtext ${styles.ctrl} ${this.state.inputClassName ?? ''} ${validError && 'p-error'}`}
            style={{ ...{ height: this.state.height }, ...this.state.inputStyle }}
          />
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
      </div>
    );
  }
  
  change = (value?: string) : string | undefined => {
    const { onChange, validate, isValid } = this.props;

    let error = this.validate(value);
    if (validate) error = validate(value);
    if (isValid) isValid(!error, error);
    
    this.setState({ validError: error });

    if (onChange) onChange(value, error);

    return error;
  }

  private validate = (value?: string) : string | undefined => {
    const { required } = this.state;

    if (required && (value?.length ?? 0) < 1) return 'campo requerido';

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
